<template>
  <v-app>
        <v-content class="body">
            <slot/>
            <notification-bar></notification-bar>
        </v-content>
    </v-app>
</template>

<script>
import NotificationBar from './notification'
export default {
  name: 'AuthLayout',
  components: {NotificationBar},
  data(){
    return {
      
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  
</style>
